// export const CLEAR_STATE = "CLEAR_STATE";

export const CLEAR_STATE_DRIVERMNG = "CLEAR_STATE_DRIVERMNG"

export const CREATE_DRIVER_WITH_FILE = "CREATE_DRIVER_WITH_FILE";
export const CREATE_DRIVER_WITH_FILE_SUCCESS = "CREATE_DRIVER_WITH_FILE_SUCCESS";
export const CREATE_DRIVER_WITH_FILE_FAIL = "CREATE_DRIVER_WITH_FILE_FAIL";

export const DELETE_DRIVER = " DELETE_DRIVER";
export const DELETE_DRIVER_SUCCESS = " DELETE_DRIVER_SUCCESS";
export const DELETE_DRIVER_FAIL = "DELETE_DRIVER_FAIL";

export const EDIT_DRIVER = " EDIT_DRIVER";
export const EDIT_DRIVER_SUCCESS = " EDIT_DRIVER_SUCCESS";
export const EDIT_DRIVER_FAIL = "EDIT_DRIVER_FAIL";

export const CREATE_DISTRIBUTOR = " CREATE_DISTRIBUTOR";
export const CREATE_DISTRIBUTOR_SUCCESS = " CREATE_DISTRIBUTOR_SUCCESS";
export const CREATE_DISTRIBUTOR_FAIL = "CREATE_DISTRIBUTOR_FAIL";

export const CHANGE_DRIVER_PASSWORD = " CHANGE_DRIVER_PASSWORD";
export const CHANGE_DRIVER_PASSWORD_SUCCESS = " CHANGE_DRIVER_PASSWORD_SUCCESS";
export const CHANGE_DRIVER_PASSWORD_FAIL = "CHANGE_DRIVER_PASSWORD_FAIL";

export const CREATE_DRIVER_WITH_VEHICLE = "CREATE_DRIVER_WITH_VEHICLE"
export const CREATE_DRIVER_WITH_VEHICLE_SUCCESS = "CREATE_DRIVER_WITH_VEHICLE_SUCCESS"
export const CREATE_DRIVER_WITH_VEHICLE_FAIL = "CREATE_DRIVER_WITH_VEHICLE_FAIL"

export const GET_DRIVER = "  GET_DRIVER";
export const GET_DRIVER_SUCCESS = "GET_DRIVER_SUCCESS";
export const GET_DRIVER_FAIL = "GET_DRIVER_FAIL";

export const GET_ALL_DRIVER_OF_PLAN = "GET_ALL_DRIVER_OF_PLAN";
export const GET_ALL_DRIVER_OF_PLAN_FAIL = "GET_ALL_DRIVER_OF_PLAN_FAIL";
export const GET_ALL_DRIVER_OF_PLAN_SUCCESS = "GET_ALL_DRIVER_OF_PLAN_SUCCESS";

export const SEARCH_TENANT_DRIVERS = " SEARCH_TENANT_DRIVERS";
export const SEARCH_TENANT_DRIVERS_SUCCESS = " SEARCH_TENANT_DRIVERS_SUCCESS";
export const SEARCH_TENANT_DRIVERS_FAIL = " SEARCH_TENANT_DRIVERS_FAIL";

export const SEARCH_TENANT_DRIVER_PERSONAL = "SEARCH_TENANT_DRIVER_PERSONAL";
export const SEARCH_TENANT_DRIVER_PERSONAL_SUCCESS = "SEARCH_TENANT_DRIVER_PERSONAL_SUCCESS";
export const SEARCH_TENANT_DRIVER_PERSONAL_FAIL = "SEARCH_TENANT_DRIVER_PERSONAL_FAIL";

export const POST_DRIVER_INFO = "POST_DRIVER_INFO";
export const POST_DRIVER_INFO_SUCCESS = "POST_DRIVER_INFO_SUCCESS";
export const POST_DRIVER_INFO_FAIL = "POST_DRIVER_INFO_FAIL";

export const ACTIVE_MISSION_TO_DRIVER = "ACTIVE_MISSION_TO_DRIVER";
export const ACTIVE_MISSION_TO_DRIVER_SUCCESS = "ACTIVE_MISSION_TO_DRIVER_SUCCESS";
export const ACTIVE_MISSION_TO_DRIVER_FAIL = "ACTIVE_MISSION_TO_DRIVER_FAIL";

export const DELETE_MISSION_FROM_DRIVER = "DELETE_MISSION_FROM_DRIVER";
export const DELETE_MISSION_FROM_DRIVER_SUCCESS = "DELETE_MISSION_FROM_DRIVER_SUCCESS";
export const DELETE_MISSION_FROM_DRIVER_FAIL = "DELETE_MISSION_FROM_DRIVER_FAIL";

